module.exports = __webpack_public_path__ + "static/media/L6-Python.8b22f55e.svg";